<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      v-model="query"
      :placeholder="items.length === 0 ? `Создайте ${catalogName}` : `Выберите ${catalogName}`"
      autocomplete="off"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <div class="select-input-body-wrapper">
      <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
        <v-icon v-if="query" name="buttons/cross" :size="11"/>
        <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
        <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
      </button>
    </div>

    <div v-if="isFocus" class="custom-dropdown-select" :class="{ 'drop-up': dropUp }">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="onSelect(item)"
        >
          <div class="text-small">{{ item.name }}</div>
        </div>
      </div>

      <div v-if="filteredItems.length > 0 && canCreateCatalog" class="custom-dropdown-select-footer p-1 border-top">
        <b-btn class="custom-btn-primary mt-0" :disabled="isDisabled" @mousedown.prevent="showModalCatalog">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить {{ catalogName }}
        </b-btn>
      </div>

      <div v-if="filteredItems.length === 0" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>

        <b-btn v-if="canCreateCatalog" class="custom-btn-primary mt-2 w-100" :disabled="isDisabled" @mousedown.prevent="showModalCatalog">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить {{ catalogName }}
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CatalogSelect",
  props: {
    isDisabled: { type: Boolean, default: false },
    state: { type: Boolean, default: null },
    initialValue: { type: Number, default: null },
    catalogName: { type: String, required: true },
    getItemById: { type: Function, required: true },
    getList: { type: Function, required: true },
    canCreateCatalog: { type: Boolean, default: false },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      selectedItem: null,
    }
  },
  mounted() {
    this.getItems();
  },
  computed: {
    filteredItems() {
      const query = this.query ? this.query.trim().toLowerCase() : '';
      if (!query) return this.items;
      if (this.selectedItem && this.selectedItem.name.toLowerCase() === query) return this.items;
      return this.items.filter(item => item.name.toLowerCase().includes(query));
    }
  },
  watch: {
    initialValue: {
      handler(newValue) {
        if (this.selectedItem && this.selectedItem.id === newValue) return;

        this.configure(newValue);
      },
      immediate: true
    },
  },
  methods: {
    async configure(id) {
      if (id && id > 0) {
        const item = await this.getItemById(id);

        if (item) {
          this.query = item.name;
          this.selectedItem = item;
        }
      } else {
        this.onClear();
      }
    },
    async getItems() {
      this.items = await this.getList() || [];
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.selectedItem) {
        if (this.query !== this.selectedItem.name) {
          this.query = this.selectedItem.name;
        }
      } else {
        this.query = '';
      }
    },
    onClick() {
      if (this.query) {
        this.onClear();
        this.$refs.input_ref.$el.focus();
      } else {
        this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    onClear() {
      this.query = '';
      this.selectedItem = null;
      this.$emit('onSelect', null);
    },
    onSelect(item) {
      this.query = item.name;
      this.selectedItem = item;
      this.$emit('onSelect', item);
      this.onFocusOut();
    },
    showModalCatalog() {
      this.isFocus = false;
      this.$emit('open-modal');
    },
    onItemCreated(newItem) {
      this.items.push(newItem);
      this.onSelect(newItem);
    }
  }
}
</script>

<style>
.custom-dropdown-select.drop-up {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CatalogSelect.vue